import { render, staticRenderFns } from "./IntegrationLineDetailDialog.vue?vue&type=template&id=2f97048d&scoped=true&"
import script from "./IntegrationLineDetailDialog.vue?vue&type=script&lang=js&"
export * from "./IntegrationLineDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationLineDetailDialog.vue?vue&type=style&index=0&id=2f97048d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97048d",
  null
  
)

export default component.exports